export default __webpack_public_path__ + "static/media/no.e16ccc0c.jpg";